import { Select } from '@creditornot/cb-select';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { localize } from 'common/utils';

import { useExperienceModuleContext } from '../../context';
import { useExperienceEntityVenues } from '../../hooks/useEntityVenues';

const StyledSelect = styled(Select)`
  min-width: 300px;
  z-index: 10;
`;

export const VenueSelector = () => {
  const { selectedExperienceVenueEntity, setSelectedExperienceVenueEntity } = useExperienceModuleContext();
  const venueExperienceEntities = useExperienceEntityVenues();
  const { locale } = useIntl();

  const venueSelectItems = venueExperienceEntities
    .filter(experienceVenueEntity => experienceVenueEntity.experienceEntityObject.status === 'VENUE_PUBLISHED')
    .map(experienceVenueEntity => {
      const venue = experienceVenueEntity.experienceEntityObject;
      return {
        label: localize(venue.name, locale),
        value: venue.id,
      };
    });

  const handleVenueChange = (value: string) => {
    const entity = venueExperienceEntities.find(venue => venue.experienceEntityId === value);
    if (entity) {
      setSelectedExperienceVenueEntity(entity);
    }
  };

  if (!selectedExperienceVenueEntity) {
    return null;
  }

  return (
    <StyledSelect
      options={venueSelectItems}
      value={selectedExperienceVenueEntity.experienceEntityId}
      onChange={handleVenueChange}
    ></StyledSelect>
  );
};
